"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".save-manual-trade-value[_ngcontent-%COMP%]{margin-left:4px;margin-bottom:4px;background:url(https://assets.autoalert.com/img/autoalert-icons/icon-save-oceandeep.svg) no-repeat;width:20px;height:20px;display:inline-block;line-height:1}"];
exports.styles = styles;
